<template>
  <div
    ref="list"
    :class="{'user': type !== 'ITEMS'}"
    class="grid_component"
  >
    <template v-for="(item, i) of response">
      <GridItemComponent
        v-if="type === 'ITEMS'"
        ref="grid"
        :key="item.id + '' + i"
        class="pointer"
        :class="{'single_item': response.length === 1}"
        :screen="screen"
        :entity-id="item.id + ''"
        @navigate="navigate"
      />
      <GridStoreComponent
        v-if="type !== 'ITEMS'"
        ref="grid"
        :key="item.id + '' + i"
        class="pointer"
        :class="{'single_item': response.length === 1}"
        :entity-id="item.id + ''"
        @navigate="navigate"
        @followStateChanged="followStateChanged($event, item)"
      />
    </template>
    <!--    <template v-if="loading">
      <div v-for="(item, index) in placeholderGridData" :key="item.id + '' + index" class="grid_item_placeholder">
        <div class="placeholder1 animated-background" />
        <div class="placeholder2 animated-background" />
        <div class="placeholder3 animated-background" />
      </div>
    </template>-->
  </div>
</template>

<script>
import AbstractComponent from './AbstractComponent'
import GridItemComponent from './GridItemComponent'
import GridStoreComponent from './GridStoreComponent'
import utils from '~/mixins/utils'

export default {
  name: 'BaseGridComponent',
  components: { GridStoreComponent, GridItemComponent },
  extends: AbstractComponent,
  mixins: [utils],
  props: {
    filterProducts: Object,
    search: String,
    searchFeatured: String,
    screen: String,
    category: String,
    featured: String,
    featuredFilter: String,
    type: String,
    filter: Object
  },
  data () {
    return {
      skipCounter: 0,
      limit: 30,
      loading: true,
      loadFromCache: false,
      fullResponse: [],
      response: [],
      lastScrollPosition: 0,
      peopleResponse: [],
      storesResponse: [],
      categories: '',
      placeholderGridData: [1, 2, 3, 4],
      imports: {},
      searchObject: {
        endpoint: '/items/select',
        limit: 30,
        filter: 'SEARCH_NAME',
        filterParam: '',
        includeProperties: true,
        includeComments: true,
        cache: false
      },
      peopleSearchObject: {
        endpoint: '/users/select',
        filter: 'SEARCH_USER',
        filterParam: this.search,
        limit: 30,
        includeProperties: true,
        includeComments: true,
        cache: false
      },
      storesSearchObject: {
        endpoint: '/users/select',
        filter: this.search ? 'SEARCH_STORE' : 'FEATURED',
        filterParam: this.search ? this.search : '2',
        limit: 30,
        includeProperties: true,
        includeComments: true,
        cache: false
      },
      noMoreScroll: false
    }
  },
  watch: {
    featuredFilter () {
      // eslint-disable-next-line vue/no-mutating-props
      this.response = this.fullResponse.filter(store => !this.featuredFilter ? true : store.gender === this.featuredFilter || !store.gender)
    },
    async category (newVal, old) {
      this.categoryChanging = true
      this.noMoreScroll = false
      this.skipCounter = 0
      if (newVal) {
        this.resetFilters()
        window.scrollTo(0, 0)
        this.response = []
        this.noMoreScroll = false
        this.loading = true
        this.skipCounter = 0
        this.searchObject.skip = 0
        this.limit = 30
        if (newVal !== 'all') {
          this.categories = newVal
          this.searchObject.filterParam = this.categories
          this.searchObject.filter = 'CATEGORIES'
        } else {
          this.searchObject.filter = 'ALL'
        }
        const noSkip = true
        await this.fetchNextPage(noSkip)
        this.categoryChanging = false
      }
    },
    featured (newVal, old) {
      if (newVal) {
        this.resetFilters()
        window.scrollTo(0, 0)
        this.response = []
        this.loading = true
        this.noMoreScroll = false
        switch (newVal) {
          case '1':
            // FEATURED
            this.searchObject.filter = 'FEATURED'
            break
          case '7':
            // MOST WANTED
            this.searchObject.filter = 'WANTED'
            break
        }
        this.searchObject.filterParam = newVal
        this.fetchNextPage()
      }
    },
    async filter (newVal, old) {
      if (this.loadFromCache || !newVal || this.categoryChanging) {
        return
      }
      let param = {}
      switch (newVal.type) {
        case 'priceFilter':
          if (newVal && newVal.filter) {
            param = { fromPrice: newVal.filter.fromPrice }
            if (newVal.filter.toPrice) {
              param.toPrice = newVal.filter.toPrice
            }
          } else {
            delete this.searchObject.fromPrice
            delete this.searchObject.toPrice
          }
          break
        case 'genderFilter': {
          if (newVal && newVal.filter) {
            param = { gender: newVal.filter }
          } else {
            delete this.searchObject.gender
          }
          break
        }
        case 'filter': {
          if (newVal && newVal.filter) {
            param = { orderBy: newVal.filter.filter }
          } else {
            delete this.searchObject.orderBy
          }
          break
        }
      }
      if (this.searchObject.filterParam) {
        window.scrollTo(0, 0)
        this.searchObject = { ...this.searchObject, ...param }
        this.loading = true
        this.response = []
        this.noMoreScroll = false
        const response = await this.$store.dispatch('api/genericCall', this.searchObject)
        this.loading = false
        this.response = response
        this.$emit('updateCounter', response.length)
      }
    },
    search (newVal, old) {
      if (newVal && old !== newVal) {
        this.skipCounter = 0
        this.limit = 30
        this.searchObject.filter = 'SEARCH_NAME'
        this.searchObject.filterParam = newVal
        this.peopleSearchObject.filterParam = newVal
        this.storesSearchObject.filterParam = newVal
        this.response = []
        this.noMoreScroll = false
        this.loading = true
        const noSkip = true
        this.fetchNextPage(noSkip)
      }
    },
    async filterProducts (newVal, oldVal) {
      if (newVal) {
        switch (newVal.type) {
          case 'filter':
            this.loading = true
            this.response = []
            this.searchObject.orderBy = newVal.filter.filter
            this.response = await this.$store.dispatch('api/genericCall', this.searchObject)
            this.loading = false
            this.noMoreScroll = false
            this.$emit('updateCounter', this.response.length)
            break
        }
      }
    }
  },
  mounted () {
    if (this.$store.state.api.cache[window.location.href]) {
      this.loadFromCache = true
      const cache = this.$store.state.api.cache[window.location.href]
      this.searchObject = cache.searchObject
      this.peopleSearchObject = cache.peopleSearchObject
      this.storesSearchObject = cache.storesSearchObject
      this.limit = cache.limit
      this.skipCounter = cache.skipCounter
      this.response = cache.response
      this.peopleResponse = cache.peopleResponse
      this.storesResponse = cache.storesResponse
      this.noMoreScroll = cache.noMoreScroll
      this.categories = cache.categories
      setTimeout(() => {
        document.documentElement.scrollTop = cache.scrollTop
      }, 400)
      setTimeout(() => {
        document.documentElement.scrollTop = cache.scrollTop
      }, 700)
      setTimeout(() => {
        this.loadFromCache = false
      }, 1000)
      this.$store.commit('api/deleteCache', {
        key: window.location.href
      })
      this.loading = false
    } else {
      this.limit = 30
      this.searchObject.skip = 0
      if (this.category) {
        this.searchObject.filter = 'CATEGORIES'
        if (this.category !== 'all') {
          this.categories = this.category
          this.searchObject.filterParam = this.categories
        } else {
          this.searchObject.filter = 'ALL'
        }
      }

      if (this.featured) {
        switch (this.featured) {
          case '1':
            // FEATURED
            this.searchObject.filter = 'FEATURED'
            break
          case '7':
            // MOST WANTED
            this.searchObject.filter = 'WANTED'
            break
        }
        this.searchObject.filterParam = this.featured
      }

      if (this.search && !this.searchObject.filterParam) {
        this.searchObject.filterParam = this.search
      }
      switch (this.type) {
        case 'ITEMS': {
          if (this.search && !this.searchObject.filterParam) {
            this.searchObject.filterParam = this.search
          }
          // if (this.searchObject.filter === 'SEARCH_NAME' && !this.searchObject.filterParam) {
          //   return
          // }
          // this.$store.dispatch('api/genericCall', this.searchObject).then((response) => {
          //   this.response = response
          //   this.addItemDetailsToEventsLayerMultipleItems('search_' + this.searchObject.filter.toLowerCase(), 'view_item_list', response)
          //   this.retryFetchNextPage(0)
          //   this.scroll()
          // })
          this.scroll()
          break
        }
        case 'PEOPLE': {
          this.$store.dispatch('api/genericCall', this.peopleSearchObject).then((response) => {
            this.$emit('updateCounter', response.length)
            this.response = response
            this.retryFetchNextPage(0)
            this.scroll()
          })
          break
        }
        case 'STORES': {
          this.$store.dispatch('api/genericCall', this.storesSearchObject).then((response) => {
            this.$emit('updateCounter', response.length)
            if (this.featuredFilter) {
              this.fullResponse = response
              this.response = this.fullResponse.filter(store => store.gender === this.featuredFilter || !store.gender)
            } else {
              this.fullResponse = response
              this.response = response
            }
            if (this.searchFeatured) {
              this.loading = false
              this.noMoreScroll = true
            }
            this.retryFetchNextPage(0)
            this.scroll()
          })
          break
        }
      }
    }
  },
  methods: {
    retryFetchNextPage (numOfRetry = 0) {
      setTimeout(() => {
        // in case window heigher then list - scroll event not lunched
        if (this.$refs.list) {
          if (this.$refs.list.clientHeight + 300 < window.innerHeight) {
            this.fetchNextPage()
          }
        } else if (numOfRetry <= 3) {
          this.retryFetchNextPage(numOfRetry + 1)
        }
      }, 1000)
    },
    resetFilters () {
      this.searchObject = {
        endpoint: '/items/select',
        limit: 30,
        filter: 'SEARCH_NAME',
        filterParam: '',
        includeProperties: true,
        includeComments: true,
        cache: false
      }
      this.peopleSearchObject = {
        endpoint: '/users/select',
        filter: 'SEARCH_USER',
        filterParam: this.search,
        limit: 30,
        includeProperties: true,
        includeComments: true,
        cache: false
      }
      this.storesSearchObject = {
        endpoint: '/users/select',
        filter: this.search ? 'SEARCH_STORE' : 'FEATURED',
        filterParam: this.search ? this.search : '2',
        limit: 30,
        includeProperties: true,
        includeComments: true,
        cache: false
      }
    },
    followStateChanged (state, user) {
      const indexToReplace = this.response.indexOf(user)
      const cloneUser = JSON.parse(JSON.stringify(this.response.filter(userItem => userItem.id === user.id)[0]))
      cloneUser.extra.isFollowed = state
      this.$store.commit('api/updateUser', cloneUser)
      this.response.splice(indexToReplace, 1, cloneUser)
      this.response = this.response.splice(0)
      const tempArray = []
      this.response.forEach(value => tempArray.push(value))
      this.response = []
      setTimeout(() => {
        this.response = tempArray
      }, 5)
    },
    navigate (path) {
      this.$store.commit('api/storeEntities', {
        key: window.location.href,
        searchObject: this.searchObject,
        peopleSearchObject: this.peopleSearchObject,
        storesSearchObject: this.storesSearchObject,
        limit: this.limit,
        skipCounter: this.skipCounter,
        response: this.response,
        peopleResponse: this.peopleResponse,
        storesResponse: this.storesResponse,
        noMoreScroll: this.noMoreScroll,
        categories: this.categories,
        scrollTop: document.documentElement.scrollTop,
        date: new Date()
      })
      this.$router.push({
        path
      })
    },
    getCategoriId (categoryTree, categoryName) {
      if (categoryTree.subEntries) {
        if (categoryTree.name === categoryName) {
          return categoryTree.id
        }
        for (let i = 0; i < categoryTree.subEntries.length; i++) {
          if (categoryTree.subEntries[i].name === categoryName) {
            return categoryTree.subEntries[i].id
          }
        }
        /* for (let j = 0; j < categoryTree.subEntries.length; j++) {
          return this.getCategoriId(categoryTree.subEntries[j], categoryName)
        } */
      } else if (categoryTree.name === categoryName) {
        return categoryTree.id
      }
    },
    scroll () {
      window.onscroll = () => {
        if (this.noMoreScroll || !this.$refs.grid) {
          return
        }
        const lastGridElement = this.$refs.grid[this.$refs.grid.length - 1]
        if (!lastGridElement) {
          return
        }
        const bottomOfWindow = lastGridElement.$el.offsetTop - (window.scrollY + lastGridElement.$el.offsetHeight * 2) < lastGridElement.$el.offsetHeight
        if (!bottomOfWindow) {
          return
        }
        if (!this.loading) {
          this.loading = true
          this.fetchNextPage()
        }
      }
    },
    async fetchNextPage (noSkip) {
      if (!noSkip) {
        this.skipCounter++
      }
      switch (this.type) {
        case 'ITEMS': {
          this.searchObject.skip = this.limit * this.skipCounter
          // console.log('JSON.stringify(this.searchObject)')
          // console.log(JSON.stringify(this.searchObject))
          break
        }
        case 'PEOPLE': {
          this.peopleSearchObject.skip = this.limit * this.skipCounter
          break
        }
        case 'STORES': {
          this.storesSearchObject.skip = this.limit * this.skipCounter
          break
        }
      }
      this.loading = true
      let response = []
      switch (this.type) {
        case 'ITEMS': {
          if (this.searchObject.filter === 'SEARCH_NAME' && !this.searchObject.filterParam) {
            // console.log('this.searchObject missing filterParam', JSON.stringify(this.searchObject))
            return
          }
          response = await this.$store.dispatch('api/genericCall', this.searchObject)
          this.addItemDetailsToEventsLayerMultipleItems('search_' + this.searchObject.filter.toLowerCase(), 'view_item_list', response)
          break
        }
        case 'PEOPLE': {
          response = await this.$store.dispatch('api/genericCall', this.peopleSearchObject)
          break
        }
        case 'STORES': {
          response = await this.$store.dispatch('api/genericCall', this.storesSearchObject)
          break
        }
      }

      if (response.length === 0) {
        this.noMoreScroll = true
        this.loading = false
      } else {
        this.response = this.response.concat(response)
        this.loading = false
        this.$emit('updateCounter', this.response.length)
      }
    }
  }
}
</script>

<style>
.grid_component {
  display: grid;
  grid-template-columns: repeat(3, 300px);
  justify-content: center;
  grid-gap: 15px;
  grid-auto-rows: 2fr;
  padding-bottom: 50px;
}

.mobile_design .grid_component {
  grid-template-columns: repeat(2, 50%);
  grid-gap: 4px;
}

.mobile_design .grid_component.user {
  grid-template-columns: repeat(1, 100%);
  grid-auto-flow: row;
  grid-gap: 5px;
  width: 100%;
}

.single_item {
  grid-template-columns: repeat(2, 100%);
}

.mobile_design .grid_placeholder, .mobile_design .grid_component {
  /*grid-template-columns: repeat(2, 50%);*/
  grid-template-columns: 1fr 1fr;
  padding-left: 0;
  padding-right: 0;
}

.grid_placeholder {
  display: grid;
  grid-template-columns: repeat(3, 300px);
  justify-content: center;
  grid-gap: 15px;
  grid-auto-rows: 2fr;
  margin-left: auto;
}

.mobile_design .grid_placeholder {
  grid-template-columns: repeat(2, 50%);
  grid-gap: 4px;
}

.grid_placeholder {
  grid-template-columns: repeat(3, calc(191px + 45px + 0.6em));
}

.grid_item_placeholder {
  padding: 1em;
  position: relative;
  height: 360px;
  background-color: white;
}

.grid_item_placeholder {
  height: calc(191px + 45px + 0.6em);
}
</style>
